import { GET_ALL_ARTICULOS } from '../constants/action_types';

const initialState = [];

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_ALL_ARTICULOS + "_SUCCESS":
            return action.payload.data

        default:

            return state;
    }

}